var _jsxFileName = "/codebuild/output/src1493404089/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/utility/OptInOut/index.tsx";
import React, { useEffect, useRef, useState } from 'react';
import { Pressable } from 'react-native';
import { BottomSheet, Label, RadioButton, Stack, Text } from '@adc/parallax-component-library';
import i18n from 'Utilities/i18n';
import log from 'Utilities/log';
function OptInOutModal({
  previousState,
  negativeOption,
  positiveOption,
  isOpen,
  setIsOpen,
  handleUpdate
}) {
  const [optState, setOptState] = useState(previousState);
  const isUpdatedDisabled = previousState === optState;
  const isAccepted = optState === 'accept';
  const isDeclined = optState === 'decline';
  const ref = useRef(null);
  useEffect(() => {
    setOptState(previousState);
  }, [previousState, isOpen]);
  const handleClose = () => {
    setIsOpen(false);
  };
  useEffect(() => {
    if (isOpen) {
      var _ref$current;
      (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.present();
    } else {
      var _ref$current2;
      (_ref$current2 = ref.current) === null || _ref$current2 === void 0 || _ref$current2.dismiss();
    }
  }, [isOpen]);
  return /*#__PURE__*/React.createElement(BottomSheet, {
    ref: ref,
    enableDynamicSizing: true,
    topNavigationProps: {
      title: i18n.t('Global.microcopy.common.status'),
      buttonStart: {
        element: i18n.t('Global.microcopy.common.cancel'),
        onPress: handleClose,
        label: i18n.t('Global.microcopy.common.cancel')
      },
      buttonEnd: {
        element: i18n.t('Global.microcopy.common.update'),
        onPress: () => handleUpdate(optState),
        label: i18n.t('Global.microcopy.common.update'),
        disabled: isUpdatedDisabled
      }
    },
    onBackdropClick: handleClose,
    onDismiss: handleClose,
    testID: "OptInOutModal",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 65,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    flexDirection: "column",
    gap: "$4",
    marginBottom: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 86,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(RadioButton, {
    selected: isAccepted,
    label: i18n.t(positiveOption),
    onPress: () => setOptState('accept'),
    testID: positiveOption,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 87,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(RadioButton, {
    selected: isDeclined,
    label: i18n.t(negativeOption),
    onPress: () => setOptState('decline'),
    testID: negativeOption,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 93,
      columnNumber: 9
    }
  })));
}
function OptInOut({
  handleConsent,
  initialState,
  optionStrings,
  onDecline
}) {
  const [optState, setOptState] = useState(initialState);
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    setOptState(initialState);
  }, [initialState]);
  const handleUpdate = async state => {
    if (optState === state) {
      return;
    }
    if (state === 'decline' && onDecline) {
      onDecline();
      setIsOpen(false);
      return;
    }
    try {
      await handleConsent(state);
      setOptState(state);
      setIsOpen(false);
    } catch (error) {
      log.error(error);
    }
  };
  const isAccepted = optState === 'accept';
  const {
    negativeOption,
    negativeTag,
    positiveOption,
    positiveTag,
    titleTag
  } = optionStrings;
  return /*#__PURE__*/React.createElement(Stack, {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 136,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "$2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 143,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    type: "$bodyBase.medium",
    color: "$text.100",
    nativeID: titleTag,
    testID: titleTag,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 144,
      columnNumber: 9
    }
  }, i18n.t(titleTag), ":"), /*#__PURE__*/React.createElement(Label, {
    "aria-label": isAccepted ? i18n.t(positiveTag) : i18n.t(negativeTag),
    type: isAccepted ? 'success' : 'generic',
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 148,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Label.Text, {
    testID: isAccepted ? positiveTag : negativeTag,
    nativeID: isAccepted ? positiveTag : negativeTag,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 152,
      columnNumber: 11
    }
  }, isAccepted ? i18n.t(positiveTag) : i18n.t(negativeTag)))), /*#__PURE__*/React.createElement(Pressable, {
    nativeID: "Global.microcopy.common.update",
    testID: "Global.microcopy.common.update",
    onPress: () => setIsOpen(true),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 160,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    type: "$bodyBase.medium",
    color: "$interactive.core.enabled",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 165,
      columnNumber: 9
    }
  }, i18n.t('Global.microcopy.common.update'))), /*#__PURE__*/React.createElement(OptInOutModal, {
    negativeOption: negativeOption,
    positiveOption: positiveOption,
    handleUpdate: handleUpdate,
    previousState: optState,
    isOpen: isOpen,
    setIsOpen: setIsOpen,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 169,
      columnNumber: 7
    }
  }));
}
export { OptInOut };